<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<mat-dialog-content *ngIf="form" [formGroup]="form">
  <div class="control-item-component">
    <mat-card>
      <mat-card-title>
        <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">
          {{documentRequest.documentRequestId ? 'Edit' : 'Create'}}
          Request Item
        </h2>
      </mat-card-title>
      <mat-card-content>
        <div [formGroup]="form">
          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
               >
            <div style="flex:50%">
              <mat-form-field class="example-full-width" style="width: 90%;">
                <mat-label>Request ID</mat-label>
                <input matInput formControlName="requestId">
              </mat-form-field>
            </div>
            <div style="flex:50%">
              <mat-form-field class="example-full-width" style="width: 90%;">
                <mat-label>Type</mat-label>
                <input matInput formControlName="type">
              </mat-form-field>
            </div>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
               >
            <div style="flex:50%">
              <mat-form-field class="example-full-width" style="width: 90%;">
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="description"></textarea>
              </mat-form-field>
            </div>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
               >
            <div style="flex:50%">
              <mat-form-field class="example-full-width" style="width: 90%;">
                <mat-label>Contact</mat-label>
                <input matInput formControlName="contact">
              </mat-form-field>
            </div>
            <div style="flex:50%">
              <mat-form-field class="example-full-width" style="width: 90%;">
                <mat-label>Status</mat-label>
                <input matInput formControlName="status">
              </mat-form-field>
            </div>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
               >
            <div style="flex:50%">
              <mat-form-field class="example-full-width" style="width: 90%;">
                <mat-label>Request Date</mat-label>
                <input matInput
                       [matDatepicker]="RequestDatePicker"
                       name="RequestDate"
                       formControlName="requestDate"
                       required>

                <mat-datepicker-toggle matSuffix [for]="RequestDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #RequestDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div style="flex:50%">
              <mat-form-field class="example-full-width" style="width: 90%;">
                <mat-label>Approve Date</mat-label>
                <input matInput
                       [matDatepicker]="ApproveDatePicker"
                       name="ApproveDate"
                       formControlName="approveDate"
                       required>

                <mat-datepicker-toggle matSuffix [for]="ApproveDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #ApproveDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
               >

            <div style="flex:50%">
              <mat-form-field class="example-full-width" style="width: 90%;">
                <mat-label>Dependencies</mat-label>
                <input matInput formControlName="dependencies">
              </mat-form-field>
            </div>
            <div style="flex:50%">
              <mat-form-field class="example-full-width" style="width: 90%;">
                <mat-label>Justification</mat-label>
                <input matInput formControlName="justification">
              </mat-form-field>
            </div>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
               >
            <div style="flex:50%">
              <mat-form-field class="example-full-width" style="width: 90%;">
                <mat-label>Comments</mat-label>
                <textarea matInput formControlName="newComment"></textarea>
              </mat-form-field>
            </div>
            <div style="flex:50%">
              <b>Previous Comments</b>
              <p style="white-space: pre; height: 125px; overflow-y: scroll;">{{documentRequest.comments}}</p>
            </div>
          </div>
          <div class="control-item-component" *ngIf="documentRequest.documentRequestId">
            <div p-dialog-content>
              <div class="form-grid grid">
                <div class="field col">
                  <p-table [value]="documentRequest.attachments"
                           #attachments
                           styleClass="risk-table-striped">
                    <ng-template pTemplate="caption">
                      <div class="flex align-items-center">
                        <label class="block font-bold">Attachments</label>
                        <label class="ml-auto btn" style="color: var(--main-ui-color, orange);" matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}">
                            <i class="pi pi-plus"></i>
                            <input [id]="'fileBlob' + documentRequest.documentRequestId"
                                  (change)="AddAssessmentAttachment($event)"
                                  accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                                  type="file"
                                  style="display: none;" />
                        </label>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="font-bold white-space-nowrap">Name</th>
                        <th style="width: 3rem"></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-attachment>
                      <tr>
                        <td>
                          {{ attachment.name }}
                        </td>
                        <td>
                          <p-button [text]="true"
                                    icon="pi pi-trash"
                                    severity="danger"
                                    (click)="deleteAssessmentAttachment(attachment)"></p-button>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="2" class="text-center">No attachments found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
          <div class="control-item-component">
            <div p-dialog-content>
              <div class="form-grid grid">
                <div class="field col">
                  <p-table [value]="relatedControlsList"
                           #controls
                           styleClass="risk-table-striped">
                    <ng-template pTemplate="caption">
                      <div class="flex align-items-center">
                        <label class="block font-bold">Related Controls</label>
                        <p-button [text]="true"
                                  icon="pi pi-plus"
                                  (click)="addControl()"
                                  class="ml-auto"></p-button>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="font-bold white-space-nowrap">Project name</th>
                        <th class="font-bold white-space-nowrap">Compliance Area</th>
                        <th style="width: 3rem"></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-control>
                      <tr>
                        <td>
                          {{ control.projectName }}
                        </td>
                        <td>
                          {{ control.complianceAreaControlId }}
                        </td>
                        <td>
                          <p-button [text]="true"
                                    icon="pi pi-trash"
                                    severity="danger"
                                    (click)="removeControl(control.id)"></p-button>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="onSave()" style="border-radius: 6px;">Save</button>
  <button mat-raised-button style="border-radius: 6px;" (click)="onClose()">Cancel</button>
</mat-dialog-actions>


<!--<div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
               >
            <div style="flex:50%">
              <b>Attachments</b>
              <div *ngIf="documentRequest.attachments && documentRequest.attachments.length > 0">
                  <div *ngFor="let attachment of documentRequest.attachments; let attachmentRow = index">
                      <p style="white-space: pre; height: 125px; overflow-y: scroll;">
                          <a (click)="DownloadAttachment(attachment.internalName)">{{attachment.name}}</a>
                      </p>
                      <label class="btn" [for]="'fileBlob' + documentRequest.documentRequestId" *ngIf="attachmentRow == (documentRequest.attachments.length - 1)">
                          <i class="pi pi-plus"></i>
                          <input [id]="'fileBlob' + documentRequest.documentRequestId"
                                type="file"
                                (change)="AddAssessmentAttachment($event)"
                                style="display: none;" />
                      </label>
                      <button type="button"
                              pButton
                              class="risksponge-button"
                              (click)="deleteAssessmentAttachment(attachment)"
                              icon="pi pi-trash">
                      </button>
                  </div>
              </div>
              <div *ngIf="!documentRequest.attachments || documentRequest.attachments.length === 0">
                  <p>No attachments available.</p>

                  <label class="btn" [for]="'fileBlob' + documentRequest.documentRequestId" *ngIf="attachmentRow == (documentRequest.attachments.length - 1)">
                      <i class="pi pi-plus"></i>
                      <input [id]="'fileBlob' + documentRequest.documentRequestId"
                            type="file"
                            (change)="AddAssessmentAttachment($event)"
                            style="display: none;" />
                  </label>
              </div>

            </div>

          </div>-->
